<template>
  <svg width="9" height="2" viewBox="0 0 9 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.12789 1.2558L8.51157 1.2558C8.6657 1.2558 9
    1.04653 9 0.62791C9 0.209291 8.66574 -2.38419e-07 8.51163
    -2.38419e-07L5.12791 -2.38419e-07H3.87209L0.488371
    -2.38419e-07C0.334248 -2.38419e-07 0 0.209328 0 0.62791C0
    1.04649 0.334248 1.2558 0.488371 1.25578L3.87207 1.25578L5.12789
    1.2558Z" fill="#0D7BC4"/>
  </svg>
</template>

<script>
export default {
  name: 'Minus'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/Icons/Minus.vue